var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-link",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.008,
    viewBox: "0 0 18 14.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5015",
    "data-name": "Path 5015",
    d: "M34.563,28.2a4.307,4.307,0,0,0-5.549-6.55l-.048.033a.952.952,0,1,0,1.108,1.549l.048-.033a2.4,2.4,0,0,1,3.092,3.652L29.872,30.2A2.4,2.4,0,0,1,26.22,27.1l.033-.048A.952.952,0,0,0,24.7,25.948L24.672,26a4.3,4.3,0,0,0,6.547,5.546Zm-15.476-.7a4.307,4.307,0,0,0,5.549,6.55l.048-.033a.952.952,0,0,0-1.108-1.549l-.048.033a2.4,2.4,0,0,1-3.092-3.655L23.778,25.5A2.4,2.4,0,0,1,27.43,28.6l-.033.048a.952.952,0,0,0,1.549,1.108l.033-.048a4.305,4.305,0,0,0-6.547-5.549Z",
    transform: "translate(-17.825 -20.845)",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLink);
export default __webpack_public_path__ + "static/media/ic-link.bac3317be243880f2e6719d2b9101e3d.svg";
export { ForwardRef as ReactComponent };